var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_c('div',{staticClass:"empty-icon"}),_c('div',{staticClass:"empty-text"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]),_c('router-link',{staticClass:"blue-button empty-button",attrs:{"to":{ name: _vm.pathName }}},[_vm._v("\n        Перейти в каталог\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }